module.exports = __webpack_public_path__ + "img/3.cfff536a.png";